module.exports = __webpack_public_path__ + "static/media/header_logo.5e68b578.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header_logo.svg
// module id = 15
// module chunks = 0